import { useEffect } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import GoogleTranslate from '../i18n/GoogleTranslate';
import MyListButton from './MyListButton';
import ThemeToggle from '../i18n/ThemeToggle';
import RecentSearchesDrawer from '../search/RecentSearchesDrawer';
import { ColorMode } from '../../theme/buildTheme';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  mode: ColorMode;
  onToggleMode: () => void;
}

/** Mobile nav dropdown: compact panel hugging items + full-page dark backdrop. */
const MobileMenu = ({
  open, onClose, mode, onToggleMode,
}: MobileMenuProps) => {
  const theme = useTheme();

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <>
      {/* Dark backdrop below the header — does not cover the logo/hamburger */}
      <Box
        aria-hidden
        onClick={onClose}
        sx={{
          position: 'fixed',
          top: { xs: 56, sm: 64 },
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: theme.zIndex.appBar + 1,
          bgcolor: 'rgba(0, 0, 0, 0.5)',
        }}
      />

      {/* Compact white panel attached to header bottom — height hugs items */}
      <Box
        sx={{
          position: 'fixed',
          top: { xs: 56, sm: 64 },
          left: 0,
          right: 0,
          zIndex: theme.zIndex.appBar + 2,
          bgcolor: 'background.paper',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <MyListButton forceLabel onNavigate={onClose} />
        <RecentSearchesDrawer forceLabel />
        <GoogleTranslate menuMode />
        <ThemeToggle menuMode mode={mode} onToggle={onToggleMode} />
      </Box>
    </>
  );
};

export default MobileMenu;
